const getSelectStyles = ( filterWidth, filterHeight, isSVP, isMVP, isMulti, useMaxWidth ) => {

    return {
        container: ( styles ) => {

            return {
                ...styles,
                margin: '0 0 30px'
            };

        },
        option: ( provided, state ) => ( {
            ...provided,
            color: state.isDisabled ? '#d8d8d8' : '#001d4e',
            backgroundColor: 'transparent',
            fontFamily: 'Graphik-Regular',
            position: 'relative',
            padding: '8px 12px',
            '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: state.isDisabled ? 'none' : 'underline'
            },
            '&:after': {
                content: '""',
                width: '15px',
                height: '15px',
                display: state.isSelected ? 'inline-block' : 'none',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                margin: '0',
                position: 'absolute',
                right: '10px',
                bottom: '30%',
                backgroundImage: state.selectProps.isMulti ? 'url(/assets/images/svg/icon-utility/x.svg)' : 'none'
            }
        } ),
        control: ( styles, state ) => {

            return {
                ...styles,
                backgroundColor: state.isDisabled ? '#eee' : '#fff',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#929fb3',
                borderBottomColor: state.selectProps.menuIsOpen ? 'transparent' : '#929fb3',
                fontFamily: 'Graphik-Regular',
                fontSize: '16px',
                color: '#949596',
                width: useMaxWidth ? '' : filterWidth,
                maxWidth: useMaxWidth ? filterWidth : '',
                minHeight: filterHeight,
                marginRight: 10,
                '&:hover': {
                    borderColor: '#324de6'
                }
            };

        },
        singleValue: ( provided, state ) => {

            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition, color: '#011e4d' };

        },
        placeholder: ( styles, state ) => {

            return {
                ...styles,
                fontFamily: 'Graphik-Regular',
                color: state.isDisabled ? '#949596' : '#949596'
            };

        },
        indicatorsContainer: ( styles ) => {

            return {
                ...styles,
                padding: '5px 0 0',
                alignItems: 'flex-start'
            };

        },
        clearIndicator: ( styles, state ) => {

            if ( state.selectProps.isMulti ) {

                return {
                    ...styles,
                    display: 'none'
                };

            }

            return {
                ...styles
            };

        },
        indicatorSeparator: ( styles ) => {

            return {
                ...styles,
                width: 0
            };

        },
        dropdownIndicator: ( styles, state ) => {

            return {
                ...styles,
                color: '#001156',
                transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            };

        },
        menu: ( styles, state ) => {

            return {
                ...styles,
                backgroundColor: '#fff',
                border: '1px solid #929fb3',
                fontFamily: 'Graphik-Regular',
                fontSize: '14px',
                lineHeight: '19px',
                color: '#001d4e',
                width: filterWidth,
                margin: 0,
                maxHeight: 324,
                overflowY: 'scroll',
                borderTopLeftRadius: state.selectProps.menuIsOpen ? 0 : 5,
                borderTopRightRadius: state.selectProps.menuIsOpen ? 0 : 5,
                borderTopColor: state.selectProps.menuIsOpen ? 'transparent' : '#929fb3',
                ' > div': {
                    maxHeight: 'none'
                },
                zIndex: 999
            };

        }
    };

};

const getSelectTheme = ( theme ) => {

    return ( {
        ...theme,
        borderRadius: 5,
        colors: {
            ...theme.colors,
            primary: '#ebf0f4',
            primary25: '#ebf0f4',
            neutral40: '#001d4e',
            neutral30: '#929fb3'
        }
    } );

};

const handleOnBlur = () =>{

    const e = null;

    throw e;

};

export { getSelectStyles, getSelectTheme, handleOnBlur };